import React, { useState } from "react";
import styled from "styled-components";
import { IconChevronCircle } from "../../../../../components/Layout/Icons";
import ActionHistoryContent from "./ActionHistoryContent";

export default function ActionHistory({ order_id, id_order }) {
  const [active, setActive] = useState(true);
  return (
    <div>
      <ApplyActionItemStyled className="mb-2" active={active}>
        <div
          className={`d-flex justify-content-between px-3 cursor-pointer ${
            active ? "block-header" : ""
          } py-2`}
          onClick={() => {
            setActive((prev) => !prev);
          }}
        >
          <div>
            <span
              className={`text-xs text-font font-semi-bold`}
              style={{
                color: active ? "#03b0f7" : "#6C6C6C",
              }}
            >
              #
            </span>
            <span className="text-black">{id_order}</span>
          </div>
          <IconChevronCircle up={active} />
        </div>

        {active && <ActionHistoryContent order_id={order_id} />}
      </ApplyActionItemStyled>
    </div>
  );
}

const ApplyActionItemStyled = styled.div`
  background: #fcfcfc;
  border: 1px solid ${(props) => (props.active ? "#03B0F7" : "#d9d9d9")};
  border-radius: 4px;
  .block-header {
    background: #edf9fe;
    border-bottom: 1px solid #03b0f7;
    border-radius: 4px 4px 0px 0px;
  }
`;
